import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-608b06c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade ag-modal ag-user-modal",
  id: "agPdpLrpChooseModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "ag-modal",
  "aria-hidden": "true",
  "data-backdrop": "static"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "ag-modal-form w-100" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  colspan: "5",
  style: {"text-align":"center !important"}
}
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = {
  key: 0,
  class: "ag-badge badge badge-success p-1"
}
const _hoisted_15 = {
  key: 1,
  class: "ag-badge badge badge-success p-1"
}
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "modal-footer" }
const _hoisted_19 = {
  type: "button",
  class: "btn btn-secondary",
  "data-dismiss": "modal"
}
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t("pdpLrpSelect")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                (_ctx.modalData.rows.length > 0)
                  ? (_openBlock(), _createElementBlock("thead", _hoisted_9, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("serverName")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("pdpLrpList")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("ipUrl")), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t("zone")), 1),
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("select")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tbody", null, [
                  (_ctx.modalData.rows.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                        _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t("noData")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modalData.rows, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(row.serverName), 1),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("div", null, [
                          (row.pdpServer)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t("pdp")), 1))
                            : _createCommentVNode("", true),
                          (row.lrpServer)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("lrp")), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(row.urlHttp), 1),
                      _createElementVNode("td", null, _toDisplayString(row.zoneName), 1),
                      _createElementVNode("td", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedServers) = $event)),
                          value: row
                        }, null, 8, _hoisted_17), [
                          [_vModelCheckbox, _ctx.selectedServers]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", _hoisted_19, _toDisplayString(_ctx.$t("close")), 1),
          (_ctx.modalData.rows.length > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmSelection && _ctx.confirmSelection(...args))),
                disabled: _ctx.selectedServers.length === 0
              }, _toDisplayString(_ctx.$t("save")), 9, _hoisted_20))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}